<template>
  <div class="order_detail_wrapper">
    <div class="header">
      <div>
        <a-button icon="arrow-left" size="small" @click="() => $router.back()" />
        <span class="page_type">详情</span>
      </div>
    </div>
    <div class="content">
      <div class="common flex-row">
        <div class="left">
          <div class="basic-info">
            <div class="img-wrapper">
              <a-avatar shape="square" :size="26" :src="titlePrefix" />
            </div>
            <div>
              <div class="code">
                <span style="display: inline-block; width: 15em;">销售订单号：{{ orderCode }}</span>
                <span :class="`status-${detailInfo.status}`">
                  {{ detailInfo.statusDesc }}
                </span>
              </div>
              <div class="customer">{{ detailInfo.customerName }}</div>
            </div>
          </div>
          <a-tabs default-active-key="1" @change="handleActiveChange">
            <a-tab-pane key="1" tab="订单信息">
            </a-tab-pane>
            <a-tab-pane key="3" tab="发货记录">
            </a-tab-pane>
            <a-tab-pane key="2" tab="日志动态">
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
      <template v-if="activeKey === '1'">
        <div class="common">
          <div class="title gap-12">基本信息</div>
          <el-descriptions :column="3">
            <el-descriptions-item label="销售模式">{{
              detailInfo.dockingSystem === 'XIAOZI_ERP' ? detailInfo.saleModelDesc : '-'
            }}</el-descriptions-item>
            <el-descriptions-item label="业务类型">{{
              detailInfo.businessTypeDesc | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="关联合同">
              <span v-if="detailInfo.dockingSystem === 'XIAOZI_ERP'" @click="toContract" style="color: rgb(24, 144, 255); cursor: default;">{{ detailInfo.outContractCode | setEmpty }}</span>
              <span v-else>-</span>
            </el-descriptions-item>
            <el-descriptions-item label="客户抬头">{{
              detailInfo.customerName | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="订单来源">{{
              detailInfo.sourceTypeDesc | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="发票类型">{{
              detailInfo.invoiceTypeDesc | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="是否含税">{{
              detailInfo.dockingSystem === 'XIAOZI_ERP' ? (detailInfo.includeTaxFlag === 1 ? '含税' : '不含税') : '-'
            }}</el-descriptions-item>
            <el-descriptions-item label="结算方式">{{
              detailInfo.settleWayDesc | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="物流填单">{{
              detailInfo.logisticsFillTypeDesc | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="订单确认人">{{
              detailInfo.orderConfirmUserName | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="客户联系人">{{
              detailInfo.customerContactName | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="联系人电话">{{
              detailInfo.customerContactPhone | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="联系人邮箱">{{
              detailInfo.customerContactEmail | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="创建时间">{{
              formatDate(detailInfo.createTime)
            }}</el-descriptions-item>
            <el-descriptions-item label="对方单据号" :span="2">{{
              detailInfo.outOrderCode | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="收货信息" :span="3">{{
              `${detailInfo.receiverName || ''}_${detailInfo.receiverPhone || ''}_${detailInfo.receiverProvinceName || ''}${detailInfo.receiverCityName || ''}${detailInfo.receiverAreaName || ''}${detailInfo.receiverDetailAddress || ''}` || '--'
            }}</el-descriptions-item>
            <el-descriptions-item label="备注">{{
              detailInfo.remark | setEmpty
            }}</el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="common">
          <div class="title gap-12">物资信息</div>
          <vxe-grid
            ref="xGrid"
            size="small"
            auto-resize
            resizable
            border="inner"
            align="left"
            highlight-current-row
            highlight-hover-row
            show-overflow
            show-footer
            :columns="columns"
            :data="detailInfo.orderGoodsList"
            :footer-method="footerMethod"
            :merge-footer-items="footerItems">
            <template #imageList="{ row }">
              <span v-if="row.image && row.image.split(',').length > 0">
                <span v-for="(img, i) in row.image.split(',')" :key="'img-'+i">
                  <el-image v-if="i < 2" style="width: 32px; height: 32px; margin-right: 5px;" :src="img" :preview-src-list="row.image.split(',')" />
                </span>
                <span v-if="row.image.split(',').length > 2" style="color:#3182bd; margin-left: 2px;">...</span>
              </span>
              <span v-else>暂无图片</span>
            </template>
            <template slot="empty">
              <el-empty :image="require('@/assets/empty.svg')" :image-size="100" description="暂无数据"></el-empty>
            </template>
          </vxe-grid>
        </div>
      </template>
      <template v-if="activeKey === '2'">
        <div class="common">
          <TableWithPagination :columnList="logColumns" :tableData="logData" />
        </div>
      </template>
      <template v-if="activeKey === '3'">
        <div v-if="shippedOrders.length > 0" class="common">
          <a-tabs :default-active-key="0" @change="handleShippedActiveChange">
            <a-tab-pane v-for="(item, index) in shippedOrders" :key="index" :tab="`发货单${index + 1}`"></a-tab-pane>
          </a-tabs>
          <el-descriptions :column="3">
            <el-descriptions-item label="物流填单">{{ openShippedDetail.logisticsFillTypeDesc | setEmpty }}</el-descriptions-item>
            <el-descriptions-item label="物流公司">{{
            openShippedDetail.logisticsList && openShippedDetail.logisticsList.length > 0 ? openShippedDetail.logisticsList[0].logisticsCompanyName : '' | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="物流单号">{{
            openShippedDetail.logisticsList && openShippedDetail.logisticsList.length > 0 ? openShippedDetail.logisticsList[0].code : '' | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="发货单号">
              <span v-if="openShippedDetail.code" @click="toShippedDetail" style="color: rgb(24, 144, 255); cursor: default;">{{ openShippedDetail.code | setEmpty }}</span>
              <span v-else>-</span>
            </el-descriptions-item>
            <el-descriptions-item label="收货人姓名">{{ openShippedDetail.receiverName | setEmpty }}</el-descriptions-item>
            <el-descriptions-item label="联系电话">{{ openShippedDetail.receiverPhone | setEmpty }}</el-descriptions-item>
            <el-descriptions-item label="收货人地址" :span="3">{{
              `${openShippedDetail.receiverProvinceName || ''}${openShippedDetail.receiverCityName || ''}${openShippedDetail.receiverAreaName || ''}${openShippedDetail.receiverDetailAddress || ''}` || '--'
            }}</el-descriptions-item>
          </el-descriptions>
          <!--
            ERP 直发的物资明细按件一条，大额订单可达数万条，走服务端分页；
            其余情况数据是随发货单一次性下发的，走客户端分页。两者共用同一套分页状态。
          -->
          <TableWithPagination
            :columnList="shippedOrdersColumns"
            :tableData="goodsTableData"
            :mergeCells="mergeCells"
            :pagination.sync="goodsPagination"
            @current-change="handleGoodsPageChange" />
        </div>
        <Empty v-else style="padding-top: 50px;" class="common" />
      </template>
    </div>
  </div>
</template>
<script>
import * as Moment from 'dayjs';
import TableWithPagination, {
  TablePaginationMixin,
} from '@/components/common/TableWithPagination';
import { queryOrderDetail, orderLogs } from '@/api/pickUpOrders';
import { queryPage, queryGoodsSerialPage } from '@/api/invoiceMgr';
import setTableCols from './configs';
import { logTypes } from '@/model/logTypes';
import { queryLogListById } from '@/api/saleContract';
import { decisionEnums } from '@/model/saleContract';
import { dateFormat } from '@/utils/dateFormat.js';
import Empty from '@/components/empty.vue';

const logColumns1 = [
  {
    prop: 'logType',
    label: '事项类型',
    width: '300px',
    tooltip: true,
    render: (h, { row }) => {
      let val = '--';

      for (let v of logTypes) {
        if (v.value === row.logType) {
          val = v.label;
          break;
        }
      }

      return h('span', val);
    },
  },
  {
    prop: 'createTime',
    label: '时间',
    width: '300px',
    tooltip: true,
  },
  {
    prop: 'content',
    label: '日志内容',
    tooltip: true,
  },
];

const logColumns2 = [
  {
    prop: 'eventTypeDesc',
    label: '事项类型',
    width: '300px',
    tooltip: true,
  },
  {
    prop: 'createTime',
    label: '时间',
    width: '300px',
    tooltip: true,
    format: (val) => val && dateFormat(val).format('YYYY-MM-DD HH:mm:ss'),
  },
  {
    prop: 'content',
    label: '日志内容',
    tooltip: true,
  },
];

export default {
  name: 'sale_contract_detail',
  mixins: [TablePaginationMixin],
  components: {
    TableWithPagination,
    Empty,
  },
  props: {
    orderCode: {
      type: String,
    },
    id: {
      type: String,
    },
    dockingSystem: {
      type: String,
    },
  },
  filters: {
    setEmpty (val) {
      return val ? val : '--';
    },
  },
  data () {
    return {
      titlePrefix: require('@/assets/title_prefix.svg'),
      activeKey: '1',
      decisionEnums,
      detailInfo: {
        orderGoodsList: [],
      },
      columns: setTableCols.call(this, 'detail2'),
      activeShippedKey: 0,
      // 发货物资明细分页。ERP 直发走服务端分页（按件一条，可达数万条），其余走客户端分页
      isErpDirectDelivery: false,
      goodsTableData: [],
      allGoodsDetailList: [],
      goodsPagination: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      shippedOrdersColumns: setTableCols.call(this, 'shippedOrders'),
      openShippedDetail: {
        deliveryGoodsList: [],
      },
      logData: [],
      logColumns: [],
      shippedOrders: [],
      mergeCells: [],
      footerItems: [{ row: 0, col: 1, rowspan: 1, colspan: 30 }],
    };
  },
  created () {
    this.getOrderDetail();
    this.getShippedOrders();
    this.getLog();
  },
  methods: {
    formatDate (text) {
      return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '';
    },
    convertToName (enums, value) {
      let label = '--';

      for (let v of enums) {
        if (Number(v.value) === Number(value)) {
          label = v.label;
          break;
        }
      }

      return label;
    },
    handleActiveChange (v) {
      this.activeKey = v;
    },
    // // 动态计算合并单元格配置
    // calculateMergeCells (list) {
    //   const mergeCells = [];
    //   let rowIndex = 0;
    //   const fieldToCol = {
    //     '商品编码（sku）': 0,
    //     '商品名称': 1,
    //     '规格': 2,
    //     '型号': 3,
    //     '所属品牌': 4,
    //     '生产商': 5,
    //     '厂家编码': 6,
    //     '是否医疗件': 12,
    //     '产品注册证/备案凭证': 13,
    //   };
    //   const colIndices = Object.values(fieldToCol);

    //   while (rowIndex < list.length) {
    //     const currentDeliveryGoodsId = list[rowIndex].deliveryGoodsId;
    //     // 统计当前deliveryGoodsId的连续行数
    //     let groupRow = 1;
    //     // 如果currentDeliveryGoodsId为空，直接跳过
    //     if (!currentDeliveryGoodsId) {
    //       rowIndex++;
    //       continue;
    //     }
    //     while (rowIndex + groupRow < list.length && list[rowIndex + groupRow].deliveryGoodsId === currentDeliveryGoodsId) {
    //       groupRow++;
    //     }
    //     // 为当前分组的列添加合并配置
    //     colIndices.forEach(col => {
    //       mergeCells.push({
    //         row: rowIndex,
    //         col: col,
    //         rowspan: groupRow,
    //         colspan: 1,
    //       });
    //     });
    //     rowIndex += groupRow;
    //   }
    //   return mergeCells;
    // },
    handleShippedActiveChange (v) {
      if (!this.shippedOrders.length) {
        return;
      }
      let deliveryGoodsDetailList = [];
      this.shippedOrders[v].deliveryGoodsList = this.shippedOrders[v].deliveryGoodsList || [];
      this.goodsPagination.currentPage = 1;
      // ERP直发-按件展示商品详情。
      // 明细是按件一条，大额订单可达数万条，改由 queryGoodsSerialPage 服务端分页获取。
      if (this.shippedOrders[v].dockingSystem === 'XIAOZI_ERP' && this.shippedOrders[v].directFlag === 1) {
        this.openShippedDetail = this.shippedOrders[v] || {};
        this.activeShippedKey = v;
        this.isErpDirectDelivery = true;
        this.allGoodsDetailList = [];
        this.getErpGoodsSerialList();
        return;
      } else {
        this.isErpDirectDelivery = false;
        this.shippedOrders[v].deliveryGoodsList.map((item) => {
          if (item.deliveryGoodsSerialList?.length) {
            // item.deliveryGoodsSerialList.map((serialItem, index) => {
            //   deliveryGoodsDetailList.push({
            //     id: `${item.id}-${index}`,
            //     deliveryGoodsId: item.id,
            //     ...item,
            //     ...serialItem,
            //   });
            // });
            let deliveryGoodsSerial = {};
            deliveryGoodsSerial = item.deliveryGoodsSerialList[0];
            deliveryGoodsDetailList.push({
              ...item,
              productionDate: deliveryGoodsSerial.productionDate,
              expiryDate: deliveryGoodsSerial.expiryDate,
              batchNo: deliveryGoodsSerial.batchNo,
              serialNo: deliveryGoodsSerial.serialNo,
            });
          } else {
            deliveryGoodsDetailList.push(item);
          }
        });
      }

      // this.mergeCells = this.calculateMergeCells(deliveryGoodsDetailList);
      this.shippedOrders[v].deliveryGoodsDetailList = deliveryGoodsDetailList;
      this.openShippedDetail = this.shippedOrders[v] || {};
      this.activeShippedKey = v;
      // 非 ERP 直发：明细随发货单一次性下发，客户端分页
      this.allGoodsDetailList = deliveryGoodsDetailList;
      this.goodsPagination.total = deliveryGoodsDetailList.length;
      this.sliceGoodsTableData();
    },
    // 翻页：ERP 直发走接口，其余在本地切片
    handleGoodsPageChange () {
      if (this.isErpDirectDelivery) {
        this.getErpGoodsSerialList();
      } else {
        this.sliceGoodsTableData();
      }
    },
    sliceGoodsTableData () {
      const { currentPage, pageSize } = this.goodsPagination;
      const start = (currentPage - 1) * pageSize;
      this.goodsTableData = this.allGoodsDetailList.slice(start, start + pageSize);
    },
    toContract () {
      if (this.detailInfo.dockingSystem === 'XIAOZI_ERP' && this.detailInfo.outContractCode) {
        this.$router.push({
          path: '/salesManagement/saleContract/detail',
          query: {
            id: this.detailInfo.outContractId,
            type: 'detail',
          },
        });
      }
    },
    toShippedDetail () {
      this.$router.push({
        path: '/logistics/invoiceMgr/detail',
        query: {
          id: this.openShippedDetail.id,
          outDeliveryId: this.openShippedDetail.outDeliveryId,
          arrivalCode: this.openShippedDetail.code,
          orderId: this.openShippedDetail.orderId,
          orderCode: this.openShippedDetail.orderCode,
          arrivalSts: this.openShippedDetail.status,
          unit: this.openShippedDetail.customerName,
          outOrderId: this.openShippedDetail.outOrderId,
          dockingSystem: this.openShippedDetail.dockingSystem,
        },
      });
    },
    getShippedOrders () {
      const query = this.$route.query;
      queryPage({
        orderId: query.id,
        findDeliveryGoodsFlag: true,
        findDeliveryGoodsSerialFlag: true,
        findLogisticsFlag: true,
        findOrderFlag: true,
        pageFlag: false,
        status: 1,
      }).then(({ body }) => {
        this.shippedOrders = body?.list || [];
        this.handleShippedActiveChange(0);
      });
    },
    // ERP 直发的发货物资明细分页查询。
    // 接口返回的是 ERP（SCM）侧的字段名，这里映射成本页表格列使用的字段名。
    getErpGoodsSerialList () {
      const outDeliveryId = this.openShippedDetail.outDeliveryId;
      if (!outDeliveryId) {
        this.goodsTableData = [];
        this.goodsPagination.total = 0;
        return;
      }
      queryGoodsSerialPage({
        id: outDeliveryId,
        pageNum: this.goodsPagination.currentPage,
        pageSize: this.goodsPagination.pageSize,
      }).then(({ body }) => {
        const list = (body.list || []).map(i => ({
          ...i,
          skuCode: i.goodsCode,
          manufacturer: i.producer,
          quantity: i.currentArrivalNum,
          batchNo: i.productionBatchNumber,
          serialNo: i.productionSerialNumber,
          medicalFlag: i.isMedichair === 1,
          certificateNumber: i.regNo,
        }));
        this.goodsTableData = list;
        this.goodsPagination.total = body.total || 0;
      });
    },
    getOrderDetail () {
      const query = this.$route.query;
      queryOrderDetail({
        findOrderGoodsFlag: true,
        id: query.id,
      }).then(({ body }) => {
        this.detailInfo = body || {};
        this.detailInfo.orderGoodsList = body.orderGoodsList || [];
      });
    },
    getLog () {
      if (this.dockingSystem === 'XIAOZI_ERP') {
        this.logColumns = logColumns1;
        queryLogListById({
          id: this.id,
        }).then(({ body }) => {
          this.logData = body || [];
        });
      } else {
        this.logColumns = logColumns2;
        orderLogs({
          businessId: this.id,
          businessType: 'SALE_ORDER',
          module: 'SALE',
          orderBy: [{
            orderByType: 'DESC',
            orderByProperty: 'lastUpdateTime',
          }],
          pageFlag: false,
        }).then(({ body }) => {
          this.logData = body?.list || [];
        });
      }
    },
    footerMethod ({ data }) {
      if (!data.length) {
        return [];
      }

      let totalAmount = 0;
      let totalPrice = 0;

      data.forEach((v) => {
        totalAmount += Number(v.quantity);
        totalPrice += Number(v.taxPrice * 100 * v.quantity);
      });

      return [['合计', `数量：${totalAmount},  总金额：${(totalPrice / 100).toLocaleString('en-US', { minimumFractionDigits: 2 })}`]];
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin tag_round() {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: normal;
}
.order_detail_wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;

  .header {
    height: 52px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;

    .page_type {
      font-size: 16px;
      font-weight: bold;
      margin-left: 1em;
    }
  }

  .content {
    flex: 1;
    padding: 8px 0 0;
    overflow: auto;

    .gap-12 {
      margin-bottom: 12px;
    }

    .common {
      background-color: #fff;
      padding: 12px;
      margin-bottom: 6px;

      &.flex-row {
        display: flex;
        justify-content: space-between;
        padding-right: 0;
        padding-bottom: 0;

        .left {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .basic-info {
            display: flex;
            align-items: center;

            .img-wrapper {
              width: 40px;
              height: 40px;
              background-color: #E2F3FE;
              border-radius: 4px;
              margin-right: 6px;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .code {
              font-size: 14px;
              color: #929AA6;
              /**
              * 订单状态【0->草稿 1->待审核 2->已驳回 3->执行中 4->已取消 5->已完成 6->待确认 7->已关闭】
              */
              .status-0,
              .status-4,
              .status-7 {
                @include tag_round();
                color: #1F2733;
                background-color: #F2F4F7;
              }

              .status-2 {
                @include tag_round();
                background-color: #FEE9E5;
                color: #FF5959;
              }

              .status-1,
              .status-3,
              .status-6 {
                @include tag_round();
                background-color: #E2F3FE;
                color: #237FFA;
              }

              .status-5 {
                @include tag_round();
                background-color: #E5FEEB;
                color: #14CA64;
              }
            }

            .customer {
              font-size: 16px;
              font-weight: 600;
            }
          }

          /deep/ .ant-tabs-bar {
            margin: 0;

            .ant-tabs-nav {
              .ant-tabs-tab {
                margin-right: 16px;
              }
            }
          }
        }
      }

      .title {
        font-weight: bold;
      }
    }
  }

  /deep/ .el-descriptions-item__content {
    overflow: hidden;
    word-break: keep-all;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
